import type { IconSvgObject } from './types';

const ChartBarIncreasingIcon: IconSvgObject = [
  ["path", { d: "M7 6H11M7 11H15M7 16H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 3V13C3 16.7712 3 18.6569 4.17157 19.8284C5.34315 21 7.22876 21 11 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartBarIncreasingIcon;
